module.exports = __webpack_public_path__ + "media/images/logos/innovate_uk-1161966733aee2ab0b37be34155cf99e.png";